/** ACT2-1108: the workspace's pending invites, for the invite step's list and its done subtitle. */
import { useQuery } from '@tanstack/react-query';

import { useOrpc } from '@/_shared/hooks/useOrpc';

export function usePendingInvites() {
  const orpc = useOrpc();
  const { data } = useQuery(orpc.workspace.listInvites.queryOptions({ input: { filter: 'active_pending' } }));
  return data?.invites ?? [];
}
